<table mat-table [dataSource]="dataSourceUtilisateurs.data">
  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef>Nom</th>
    <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
  </ng-container>
  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef>Prénom</th>
    <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
  </ng-container>
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>
  <ng-container matColumnDef="roles">
    <th mat-header-cell *matHeaderCellDef>Rôle</th>
    <td mat-cell *matCellDef="let element">
      @if(currentEdit?.id === element.id){
      <div>
        @for(item of adminItems;track item){
        @if (item.name!==ROLE_ACCUEIL){
        <mat-checkbox [checked]="currentEdit?.roles?.includes(item.role)"
          (change)="toggleRole(currentEdit, item.role, $event.checked)">
          {{ item.name }}
        </mat-checkbox>
        }
        }
      </div>
      }

      @if(currentEdit?.id !== element.id) {
      <div>
        @for(item of adminItems; track item){
        @if (item.name!==ROLE_ACCUEIL){
        <mat-checkbox [checked]="element.roles.includes(item.role)" [disabled]="true">{{ item.name }}</mat-checkbox>
        }
        }
      </div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>Action</th>
    <td mat-cell *matCellDef="let element">
      @if(currentEdit?.id === element.id){
      <div class="grp-btn-edit">
        <button mat-raised-button class="btn-save" color="accent" (click)="onSaveEdit()">
          <mat-icon>save</mat-icon>
          Sauvgarder</button>
        <button mat-raised-button class="btn-cancel" (click)="onCancelEdit()">
          <mat-icon>cancel</mat-icon>
          Annuler</button>
      </div>
      }
      @if(currentEdit?.id !== element.id){
      <div class="grp-btn-action">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon color="primary">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="editUser(element)">
            <mat-icon color="primary">edit</mat-icon>
            <span>{{ 'Modifier '}}</span>
          </button><button mat-menu-item (click)="onInactivate(element)">
            <mat-icon color="primary">block</mat-icon>
            <span>{{ 'Désactiver '}}</span>
          </button>
        </mat-menu>
      </div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="statut">
    <th mat-header-cell *matHeaderCellDef>Statut</th>
    <td mat-cell *matCellDef="let element">
      {{ getStatut(element.enabled) }}
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell center" colspan="12">Aucun utilisateur trouvé pour cette officine</td>
  </tr>
</table>
